import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class DeliveryOrdersFetchAPI {

    //Function to get delivery orders by business and branch office
    static async getDeliveryOrders(business_code, branchoffice_code, minDate, maxDate, platform, status, token) {
        let url = `/deliveryOrder?business_code=${business_code}&branchoffice_code=${branchoffice_code}&minDate=${minDate}&maxDate=${maxDate}`

        if (platform !== null && platform !== undefined && platform !== '') {
            url += `&platform=${platform}`
        }

        if (status !== null && status !== undefined && status !== '') {
            url += `&status=${status}`
        }

        const res = await server(`${url}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to update a pedidosya delivery order
    static async updatePedidosYaDeliveryOrder(data, token) {
        const res = await server(`/pedidosya/updateStatusOrder`, {
            method: "put",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to update a uber eats delivery order
    static async updateUberEatsDeliveryOrder(uber_order_id, branchoffice_id, reason, external_reference_id, commets, promotion, status, code, explanation, token) {
        let url = `/ubereats/accept_order`;
        let data = {}
        if (status === "accept_pos_order") {
            url = `/ubereats/accept_pos_order`;
            data = {
                reason: reason,
                external_reference_id: external_reference_id,
                commets: commets,
                promotion: promotion,
                status: status
            }
        }

        if (status === "deny_pos_order") {
            url = `/ubereats/deny_pos_order`;
            data = {
                "explanation": explanation,
                "code": code
            }
        }

        if (status === "cancel_pos_order") {
            url = `/ubereats/deny_pos_order`;
        }
        //We add to the url the branchoffice_id and uber_order_id
        url += `?branchoffice_id=${branchoffice_id}&uber_order_id=${uber_order_id}`
        //We add to the url the reason, external_reference_id, commets, promotion and status
        const res = await server(`${url}`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Update delivery order 
    static async updateDeliveryOrder(token, delivery_order_id, data) {
        const res = await server(`/deliveryOrder/${delivery_order_id}`, {
            method: "put",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res;
    }

    //Function to register the delivery order
    static async registerDeliveryOrder(token, data) {
        const res = await server(`/deliveryOrder`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: data,
        });
        return res;
    }


    //Function to consolidate pending orders to be registered in the system
    static async consolidateOrders(token, delivery_order_ids, user_id, machine_id) {
        const res = await server(`/deliveryOrders/consolidatedRegisterPayload`, {
            method: "post",
            headers: { 'x-access-token': token },
            data: {
                delivery_order_ids: delivery_order_ids,
                user_id: user_id,
                machine_id: machine_id
            },
        });
        return res;
    }

    //Function to update the delivery orders status to registered after consolidating and registering the consolidated order
    static async updateConsolidatedOrdersStatus(token, delivery_order_ids, response_registration, registered_by, consolidation_group_id) {
        const res = await server(`/deliveryOrders/consolidatedRegisterPayload`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: {
                delivery_order_ids: delivery_order_ids,
                response_registration: response_registration,
                registered_by: registered_by,
                consolidation_group_id: consolidation_group_id
            },
        });
        return res;
    }

}
